import { format } from "date-fns";
import { Link } from "react-router-dom";
import { useDeleteOrderMutation } from "../ordersApiSlice";

export default function OrderRow({ order }) {
  const [deleteOrder, { isLoading }] = useDeleteOrderMutation();

  const created = order.created_at
    ? format(new Date(order.created_at), "yyyy-MM-dd HH:mm")
    : "—";

  const totalAmount = Number(order.total_amount || 0);

  const handleDelete = async () => {
    try {
      await deleteOrder({ id: order.id }).unwrap();
      alert(`Order '${order.order_id}' deleted successfully`);
    } catch (err) {
      console.error("Delete error:", err);
      alert(err?.data?.message || "Failed to delete order");
    }
  };

  return (
    <tr className="hover:bg-gray-50/40">
      <td className="px-6 py-3 text-sm text-gray-900 font-medium">{order.order_id}</td>
      <td className="px-6 py-3 text-sm text-gray-600">{order.table_name || "—"}</td>
      <td className="px-6 py-3 text-sm text-gray-600">{order.customer_id || "—"}</td>
      <td className="px-6 py-3">
        {order.status === "PAID" ? (
          <span className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-medium text-emerald-700 ring-1 ring-inset ring-emerald-200">
            <span className="h-1.5 w-1.5 rounded-full bg-emerald-500"></span> PAID
          </span>
        ) : order.status === "OPEN_UNPAID" ? (
          <span className="inline-flex items-center gap-1 rounded-full bg-amber-50 px-2.5 py-1 text-xs font-medium text-amber-700 ring-1 ring-inset ring-amber-200">
            <span className="h-1.5 w-1.5 rounded-full bg-amber-500"></span> OPEN
          </span>
        ) : (
          <span className="inline-flex items-center gap-1 rounded-full bg-rose-50 px-2.5 py-1 text-xs font-medium text-rose-700 ring-1 ring-inset ring-rose-200">
            <span className="h-1.5 w-1.5 rounded-full bg-rose-500"></span> {order.status || "UNKNOWN"}
          </span>
        )}
      </td>
      <td className="px-6 py-3 text-sm text-gray-600">
        Rp {totalAmount.toLocaleString("id-ID")}
      </td>
      <td className="px-6 py-3 text-sm text-gray-600">{created}</td>
      <td className="px-6 py-3 text-right">
        <div className="inline-flex gap-2">
          <Link
            to={`/dash/orders/${order.id}`}
            className="rounded-xl border border-gray-200 bg-white px-3 py-1.5 text-xs text-gray-700 hover:bg-gray-50"
          >
            Edit
          </Link>
          <button
            onClick={handleDelete}
            disabled={isLoading}
            className="rounded-xl border border-gray-200 bg-white px-3 py-1.5 text-xs text-gray-700 hover:bg-gray-50"
          >
            {isLoading ? "Deleting..." : "Delete"}
          </button>
        </div>
      </td>
    </tr>
  );
}